import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { style: {"min-width":"700px","width":"60vw","margin":"auto","margin-top":"40px"} }
const _hoisted_2 = {
  key: 0,
  class: "border-box"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  style: {"text-decoration":"line-through"}
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = {
  key: 0,
  class: "input-group input-group-sm"
}
const _hoisted_13 = ["value"]

import { computed, onMounted, watch, ref } from 'vue'
    import { useRouter } from 'vue-router'
    import { guid } from '@common/Guid'
    import { copyToClipboard } from '@common/Common'
    import { useOrganizationUnitId } from '@common/composables'
    import { useMyAccessTokensPage } from '@Organizations/AccessTokens/pages-core'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MyAccessTokensPage',
  setup(__props) {

    document.title = "Manage access tokens"

    const router = useRouter()

    const id = ref()
    const secret = ref()
    const copied = ref(false)

    const {
        useCurrentUserQuery,
        useUserAccessTokensQuery,
        useGenerateAccessTokenCommand,
        useRevokeAccessTokenCommand,
    } = useMyAccessTokensPage()

    const accessToken = computed(() => btoa(`${id.value}/${secret.value}`))

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)
    const organizationUnitId = computed(() => modelCurrentUserQueryV1.value?.OrganizationUnitId)

    const { modelUserAccessTokensQueryV1, runUserAccessTokensQueryV1, succeed: succeedUserAccessTokensQueryV1 } = useUserAccessTokensQuery(userId)
    const accessTokens = computed(() => modelUserAccessTokensQueryV1.value?.AccessTokens || [])

    const { invokeGenerateAccessTokenCommandV1, succeedGenerateAccessTokenCommandV1 } = useGenerateAccessTokenCommand(id, organizationUnitId, userId, secret)

    const { invokeRevokeAccessTokenCommandV1, succeedRevokeAccessTokenCommandV1 } = useRevokeAccessTokenCommand(null, userId)

    onMounted(() => runCurrentUserQueryV1())

    watch(userId, () => runUserAccessTokensQueryV1())

    watch(succeedGenerateAccessTokenCommandV1, () => runUserAccessTokensQueryV1())
    watch(succeedRevokeAccessTokenCommandV1, () => runUserAccessTokensQueryV1())

    function handleGenerateAccessTokenCommandV1() {
        id.value = guid()
        secret.value = `${guid()}${guid()}`.replace(/-/g, '')
        invokeGenerateAccessTokenCommandV1()
    }

    function handleRevokeAccessTokenCommandV1(token) {
        if (confirm(`Do you really want to revoke access token ${token.Name}?`)){
            invokeRevokeAccessTokenCommandV1({id: token.Id})
        }
    }

    function handleCopyToClipboard() {
        copyToClipboard(accessToken.value)
        copied.value = true

        const h = setTimeout(() => {{
            copied.value = false
            clearTimeout(h)
        }}, 1000)
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1))),
      type: "button",
      class: "btn btn-lg btn-link"
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("i", {
        class: "fa fa-arrow-left mr-1",
        "aria-hidden": "true"
      }, null, -1 /* CACHED */),
      _createElementVNode("span", null, "Back", -1 /* CACHED */)
    ]))]),
    _createElementVNode("div", _hoisted_1, [
      _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "fg-color-blue" }, "Access tokens", -1 /* CACHED */)),
      _cache[7] || (_cache[7] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
      _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      (_unref(succeedUserAccessTokensQueryV1))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (accessTokens.value.length==0)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_3, "No access tokens generated"))
              : _createCommentVNode("v-if", true),
            _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"row\"><div class=\"col\"><strong>Name</strong></div><div class=\"col\"><strong>Expiration</strong></div><div class=\"col\"><strong>ID</strong></div><div class=\"col\"><strong>Secret</strong></div></div><hr>", 2)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accessTokens.value, (token) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (handleRevokeAccessTokenCommandV1(token)),
                    class: "btn btn-sm btn-default",
                    type: "button",
                    title: "Revoke access token"
                  }, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("i", { class: "fa-solid fa-ban" }, null, -1 /* CACHED */)
                  ]))], 8 /* PROPS */, _hoisted_6),
                  (token.IsExpired || token.IsRevoked)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(token.Name), 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(token.Name), 1 /* TEXT */))
                ]),
                _createElementVNode("div", _hoisted_9, _toDisplayString(token.ExpireAt), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_10, _toDisplayString(token.Id), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_11, [
                  (token.Id==id.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("input", {
                          value: copied.value ? 'COPIED!' : accessToken.value,
                          type: "text",
                          class: _normalizeClass(["form-control bg-white", {'text-success': copied.value}]),
                          readonly: ""
                        }, null, 10 /* CLASS, PROPS */, _hoisted_13),
                        _createElementVNode("div", { class: "input-group-append" }, [
                          _createElementVNode("button", {
                            onClick: handleCopyToClipboard,
                            class: "btn btn-outline-secondary",
                            type: "button"
                          }, [...(_cache[3] || (_cache[3] = [
                            _createElementVNode("span", { class: "fa fa-copy" }, null, -1 /* CACHED */)
                          ]))])
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ]))
            }), 256 /* UNKEYED_FRAGMENT */)),
            _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              onClick: handleGenerateAccessTokenCommandV1
            }, "Generate a new token")
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})